
<div class="p-4 h-100 align-items-center">
  <div class="row">
    <div class="col-12 text-center">
      <ion-icon [color]="iconColor" size="large" [name]="icon"></ion-icon>
    </div>
  
    <div class="col-12 text-center">
      <h3>{{title}}</h3>
    </div>
  
    <div class="col-12 text-center">
      <p>{{text}}</p>
    </div>
  
  </div>
  
  
  <div class="d-flex flex-wrap justify-content-end">
    <ion-button  fill="clear" size="small" (click)="cancel()">Cancelar</ion-button>
    <ion-button size="small" (click)="confirm()">Aceptar</ion-button>
  </div>
</div>

